import { Copy } from 'lucide-react';
import { League } from '@/hooks/useLeagueDetails';
import { Button } from '@/components/ui/button';
import BaseModal from './Bet99Modal';

interface ShareLeagueCodeModalProps {
  isOpen: boolean;
  onClose: () => void;
  league: League;
  onViewLeague: () => void;
}

export const ShareLeagueCodeModal = ({
  isOpen,
  onClose,
  league,
  onViewLeague,
}: ShareLeagueCodeModalProps) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(league.code);
  };

  return (
    <BaseModal isOpen={isOpen} onClose={onClose} title={league.name.toUpperCase()}>
      <div className="text-center space-y-6">
        <p className="text-text-secondary">
          Show this PIN to invite friends to your private league
        </p>

        {/* PIN Display */}
        <div className="flex justify-center gap-2">
          {league.code.split('').map((char, index) => (
            <div
              key={index}
              className="w-12 h-12 bg-app-surface rounded-lg flex items-center justify-center text-text-primary font-bold text-xl"
            >
              {char}
            </div>
          ))}
        </div>

        {/* Action Buttons */}
        <div>
          <Button
            data-test-id="copy-pin-btn"
            variant="secondary"
            onClick={handleCopy}
            className="w-full gap-2"
          >
            <Copy className="w-4 h-4" />
            Copy
          </Button>
        </div>

        <p className="text-text-muted text-sm">
          You can always copy your code later on the friends leaderboard page
        </p>

        <Button
          data-test-id="view-league-btn"
          variant="bet99"
          onClick={onViewLeague}
          className="w-full"
        >
          View League
        </Button>
      </div>
    </BaseModal>
  );
};
